


export const HOSPITAL_STATUS: Record<string, number > = {
    Pending :1,
    InformationRequested : 2,
    InformationResponded : 3,
    Accepted : 4,
    AwaitingInitialPayment : 5,
    InitialPaymentReceived : 6,
    InProgress: 7,
    Completed : 8,
    Discharge: 9,
    Declined : 10,
}

export const HOSPITAL_STATUS_TEXT: Record<string, string> = {
    [HOSPITAL_STATUS.Pending]: "Pending",
    [HOSPITAL_STATUS.InformationRequested]: "Information Requested",
    [HOSPITAL_STATUS.InformationResponded]: "Information Responded",
    [HOSPITAL_STATUS.Accepted]: "Accepted",
    [HOSPITAL_STATUS.AwaitingInitialPayment]: "Awaiting Initial Payment",
    [HOSPITAL_STATUS.InitialPaymentReceived]: "Initial Payment Received",
    [HOSPITAL_STATUS.InProgress]: "In Progress",
    [HOSPITAL_STATUS.Completed]: "Completed",
    [HOSPITAL_STATUS.Discharge]: "Discharge",
    [HOSPITAL_STATUS.Declined]: "Declined"
}

export const HOSPITAL_STATUS_COLOR: Record<string, string> = {
    [HOSPITAL_STATUS.Pending]: "status-color-pending",
    [HOSPITAL_STATUS.InformationRequested]: "status-color-information-requested",
    [HOSPITAL_STATUS.InformationResponded]: "status-color-information-responded",
    [HOSPITAL_STATUS.Accepted]: "status-color-accepted",
    [HOSPITAL_STATUS.AwaitingInitialPayment]: "status-color-awaiting-initial-payment",
    [HOSPITAL_STATUS.InitialPaymentReceived]: "status-color-initial-payment-received",
    [HOSPITAL_STATUS.InProgress]: "status-color-in-progress",
    [HOSPITAL_STATUS.Completed]: "status-color-completed",
    [HOSPITAL_STATUS.Discharge]: "status-color-discharge",
    [HOSPITAL_STATUS.Declined]: "status-color-declined"
}

export const HOSPITAL_STATUS_KEY: Record<number, number> = {
    [HOSPITAL_STATUS.Pending]: 1,
    [HOSPITAL_STATUS.InformationRequested]: 2,
    [HOSPITAL_STATUS.InformationResponded]: 3,
    [HOSPITAL_STATUS.Accepted]: 4,
    [HOSPITAL_STATUS.AwaitingInitialPayment]: 5,
    [HOSPITAL_STATUS.InitialPaymentReceived]: 6,
    [HOSPITAL_STATUS.InProgress]: 7,
    [HOSPITAL_STATUS.Completed]: 8,
    [HOSPITAL_STATUS.Discharge]: 9,
    [HOSPITAL_STATUS.Declined]: 10
}
